import { render, staticRenderFns } from "./TsJobItem.vue?vue&type=template&id=07b3417f"
import script from "./TsJobItem.vue?vue&type=script&lang=ts"
export * from "./TsJobItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports